import React, { useEffect, useState, useRef } from 'react';
export function EnvironmentalImpactSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
      }
    }, {
      threshold: 0.15
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return <section ref={sectionRef} className="relative bg-white py-20 overflow-hidden" data-id="element-67">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5" data-id="element-68">
        <div className="absolute inset-0" style={{
        backgroundImage: 'linear-gradient(to right, #496f58 1px, transparent 1px), linear-gradient(to bottom, #496f58 1px, transparent 1px)',
        backgroundSize: '60px 60px'
      }} data-id="element-69"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-70">
        {/* Text Content Above Video */}
        <div className={`max-w-4xl mx-auto text-center mb-8 lg:mb-8 transition-all duration-700 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} data-id="element-71">
          <p className="text-[#2d4a3a]text-primary/60 text-xs font-light uppercase tracking-wider mb-4 font-mono" data-id="element-72">
            ● Our Philosophy
          </p>
          <h2 className="text-[#2d4a3a] text-4xl md:text-6xl font-light text-primary mb-4 lg:mb-4 leading-tight" data-id="element-73">
            You are more than
            <br data-id="element-74" />
            <span className="font-normal" data-id="element-75">human.</span>
          </h2>
          <p className="text-[#2d4a3a]text-text-light text-sm leading-relaxed max-w-3xl mx-auto" data-id="element-76">
            Your body is a temple with a complex ecosystem designed with divine
            purpose. Our supplements work in harmony with your body's natural
            processes to support optimal health and vitality.
          </p>
        </div>

        {/* Video Section */}
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-77">
          <div className={`relative lg:max-w-sm lg:mx-auto transition-all duration-700 ease-out ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-12'}`} style={{
          transitionDelay: '200ms'
        }} data-id="element-78">
            <div className="relative rounded-2xl overflow-hidden aspect-square" data-id="element-79">
              <video src="https://cdn.shopify.com/s/files/1/0637/8940/0115/files/sdasfaf.mkv?v=1763924133" className="w-full h-full object-cover" autoPlay loop muted playsInline data-id="element-80" />
              <div className="absolute inset-0 bg-gradient-to-r from-primary/60 to-transparent" data-id="element-81"></div>
              {/* Quote Overlay */}
              <div className="absolute inset-0 flex items-end justify-start p-6 pb-8" data-id="element-82">
                <div className="bg-white/95 backdrop-blur-md rounded-xl p-3 max-w-[280px] border border-white/50 shadow-xl" data-id="element-83">
                  <p className="text-primary text-xs font-light italic mb-1.5 leading-relaxed" data-id="element-84">
                    "Do you not know that your bodies are temples of the Holy
                    Spirit?"
                  </p>
                  <p className="text-primary/60 text-[10px]" data-id="element-85">
                    — 1 Corinthians 6:19
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className={`flex flex-col justify-center transition-all duration-700 ease-out ${isVisible ? 'opacity-90 translate-x-0' : 'opacity-10 translate-x-12'}`} style={{
          transitionDelay: '400ms'
        }} data-id="element-86">
            <button className="bg-primary text-[#2d4a3a] px-8 py-3 rounded-full hover:bg-primary/90 transition-all duration-300 font-medium shadow-lg hover:shadow-xl" data-id="element-87">
              Discover Our Philosophy
            </button>
          </div>
        </div>
      </div>
    </section>;
}